import { Card } from '@mui/material';
import { Field } from '~/components/common/Formik2';
import { useAnnouncementDetailContext } from '../AnnouncementDetailContext';

const NameSection = () => {
  const { isArchived } = useAnnouncementDetailContext();

  return (
    <Card
      sx={{
        '.MuiFormLabel-root': {
          'marginBottom': '16px',
          '& .MuiTypography-root': {
            fontSize: 18,
            fontWeight: 600,
          },
        },
        'pointerEvents': isArchived ? 'none' : 'auto',
      }}
    >
      <Field.Input name='name' label='Name' fullWidth />
    </Card>
  );
};

export default NameSection;
